export default __webpack_public_path__ + "static/media/ios-app.b454b692.png";